import React from 'react';
import { HandWaving } from 'phosphor-react';
import { DillModal } from '../../../general/Dill/DillModal';
import { DillButton } from '../../../general/Dill/DillButton';
import { isHTML } from '../../../../utils/helpers';
import dillLogoWithText from '../../../../assets/svg/dill_logo_with_text.svg';

// Mirrors dill-backend's emailTemplates/creditAppRequestNotification.html so this looks like
// the real email instead of a bare text dump.
export const DecisionMessagePreviewModal = ({
  open,
  onClose,
  title,
  subjectLine,
  message,
  supplierLogoUrl,
  senderName,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  subjectLine?: string | null;
  message?: string | null;
  supplierLogoUrl?: string | null;
  senderName?: string;
}) => {
  return (
    <DillModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="640px"
      contentClassName="flex-1 min-h-0 overflow-y-auto p-0"
      footer={<DillButton label="Close" variant="secondary" onClick={onClose} />}>
      <div style={{ backgroundColor: '#f1f5f9' }}>
        {subjectLine && (
          <p className="text-xs font-semibold text-gray-500 px-5 pt-4 pb-1">
            Subject: {subjectLine}
          </p>
        )}
        <div className="p-4 md:p-6">
          <div
            className="rounded-lg mx-auto max-w-[520px] overflow-hidden"
            style={{ backgroundColor: '#ffffff' }}>
            <div className="flex flex-col items-center pt-6 pb-2 px-6">
              {supplierLogoUrl && (
                <img
                  src={supplierLogoUrl}
                  alt="Supplier Logo"
                  className="max-h-10 object-contain mb-2"
                />
              )}
              <div className="flex items-center gap-1">
                <span className="text-2xs text-black">Powered by</span>
                <img src={dillLogoWithText} alt="Dill" className="h-4" />
              </div>
            </div>
            <div className="px-5 pb-5">
              <div className="rounded-lg px-6 py-6" style={{ backgroundColor: '#f1f5f9' }}>
                <div className="flex justify-center mb-3">
                  <div className="w-[70px] h-[70px] rounded-full bg-[#3762fb] flex items-center justify-center">
                    <HandWaving size={36} color="#ffffff" weight="fill" />
                  </div>
                </div>
                <h3 className="text-center text-lg font-bold mb-3">Hi {senderName || 'there'}!</h3>
                {message &&
                  (isHTML(message) ? (
                    <div
                      className="text-sm text-left"
                      dangerouslySetInnerHTML={{ __html: message }}
                    />
                  ) : (
                    <p className="text-sm text-left">{message}</p>
                  ))}
              </div>
            </div>
          </div>
          <p className="text-2xs text-gray-700 mt-4 px-1">
            This email was sent to you via{' '}
            <a
              className="text-[#3762fb] underline"
              href="https://usedill.com/"
              target="_blank"
              rel="noreferrer">
              Dill
            </a>
            . If you would rather not receive email from this sender, you may contact the sender
            directly or click "Reply To".
          </p>
        </div>
      </div>
    </DillModal>
  );
};

export default DecisionMessagePreviewModal;
